import React from 'react';
import { connect } from 'react-redux';
import { EmptyCard } from 'components';
import { regenerateToken } from 'ducks/authActions';

export class RegenerateToken extends React.PureComponent {
  componentDidMount() {
    this.props.regenerateToken();
  }

  render() {
    return <EmptyCard modal message="Authorizing..." />;
  }
}

export default connect(undefined, { regenerateToken })(RegenerateToken);



// WEBPACK FOOTER //
// ./src/pages/__components__/RegenerateToken.js